import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const marketsAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = marketsAdapter.getInitialState()

export const marketsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getMarkets: builder.query({
            query: () => ({
                url: '/markets',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedMarkets = responseData.map(market => {
                    market.id = market._id
                    return market
                });
                return marketsAdapter.setAll(initialState, loadedMarkets)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Market', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Market', id }))
                    ]
                } else return [{ type: 'Market', id: 'LIST' }]
            }
        }),
        addNewMarket: builder.mutation({
            query: initialMarket => ({
                url: '/markets',
                method: 'POST',
                body: {
                    ...initialMarket,
                }
            }),
            invalidatesTags: [
                { type: 'Market', id: "LIST" }
            ]
        }),
        updateMarket: builder.mutation({
            query: initialMarket => ({
                url: '/markets',
                method: 'PATCH',
                body: {
                    ...initialMarket,
                },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Market', id: arg.id }
            ]
        }),
        deleteMarket: builder.mutation({
            query: ({ id }) => ({
                url: `/markets`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Market', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetMarketsQuery,
    useAddNewMarketMutation,
    useUpdateMarketMutation,
    useDeleteMarketMutation,
} = marketsApiSlice

// returns the query result object
export const selectMarketsResult = marketsApiSlice.endpoints.getMarkets.select()

// creates memoized selector
const selectMarketsData = createSelector(
    selectMarketsResult,
    marketsResult => marketsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllMarkets,
    selectById: selectMarketById,
    selectIds: selectMarketIds
    // Pass in a selector that returns the markets slice of state
} = marketsAdapter.getSelectors(state => selectMarketsData(state) ?? initialState)